import React, { useRef } from "react";
import { crossSellContainerDesktop, containerTitle } from "./style.mod.scss";
import CrossSell from "../upsell-variant";
import useTrackVisibility from "hooks/useTrackVisibility";
import { trackViewItemList } from "helpers/analytics";

const CrossSellProducts = ({
  title, variants,
  crossSellVariants, setCrossSellVariants,
  setTotalPrice, totalPrice,
  totalCompareAtPrice, setTotalCompareAtPrice, enhancedPDPContent, ecoPackage, pdpSettings,
  overwriteSettingsCrossSell, crossSellStyle, uniqueKey
}) => {
  let crossSellTitle = (overwriteSettingsCrossSell || variants?.length > 0) ? title : pdpSettings?.crossSellText ?? title;
  let crossSells = overwriteSettingsCrossSell ? variants : pdpSettings?.variants ?? variants;

  const listRef = useRef(null);
  const hasTracked = useRef(false);

  const onVisible = () => {
    if (!hasTracked.current) {
      trackViewItemList({
        title: crossSellTitle,
        products: crossSells,
        list: "Cross Sell",
        id: uniqueKey ?? "aw38ej2"
      });
      hasTracked.current = true;
    }
  };

  useTrackVisibility(listRef, onVisible, { threshold: 0.3 });

  const addVariantToCart = (variant) => {
    const variantAdded = crossSellVariants[variant?.id];
    const variantPrice = parseFloat(variant?.store?.price);
    const variantPriceAtCompare = parseFloat(variant?.store?.compareAtPrice);
    setTotalPrice(variantAdded ? (totalPrice - variantPrice) : (totalPrice + variantPrice));

    if (variantPriceAtCompare > 0) {
      setTotalCompareAtPrice(variantAdded ?
        totalCompareAtPrice - variantPriceAtCompare :
        totalCompareAtPrice + variantPriceAtCompare
      );
    } else {
      setTotalCompareAtPrice(variantAdded ?
        totalCompareAtPrice - variantPrice :
        totalCompareAtPrice + variantPrice
      );
    }

    setCrossSellVariants({
      ...crossSellVariants,
      [variant?.id]: variantAdded ? false : true
    });
  };

  return (
    <div className={crossSellContainerDesktop} ref={listRef}>
      {crossSells?.length && (<>
        {crossSellTitle && <p className={containerTitle}>{crossSellTitle}</p>}
        {crossSells?.map(v =>
          <CrossSell
            key={v?._key}
            upsell={v}
            onClick={() => addVariantToCart(v?.variant)}
            variantAdded={crossSellVariants[v?.variant?.id]}
            plusPrice={v?.variant?.store?.price}
            enhancedPDPContent={enhancedPDPContent}
            ecoPackage={ecoPackage}
            crossSellVariants={crossSellVariants}
            setCrossSellVariants={setCrossSellVariants}
            setTotalPrice={setTotalPrice}
            totalPrice={totalPrice}
            totalCompareAtPrice={totalCompareAtPrice}
            setTotalCompareAtPrice={setTotalCompareAtPrice}
            crossSellStyle={crossSellStyle}
          />
        )}
      </>)}
    </div>
  );
};

export default CrossSellProducts;
